export default "__VITE_ASSET__DiwWjQig__"